const AlertIcon = ({ width = 10, height = 20, color = 'currentColor', ...props }) => {
  return (
    <svg width="37" height="31" viewBox="0 0 37 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.9437 1.00001L35.8203 28.5C35.9666 28.7534 36.0436 29.0408 36.0436 29.3333C36.0436 29.6259 35.9666 29.9133 35.8203 30.1667C35.6741 30.42 35.4637 30.6304 35.2103 30.7767C34.9569 30.923 34.6695 31 34.377 31H2.62366C2.3311 31 2.0437 30.923 1.79034 30.7767C1.53698 30.6304 1.32659 30.42 1.18031 30.1667C1.03404 29.9133 0.957029 29.6259 0.957031 29.3333C0.957033 29.0408 1.03404 28.7534 1.18032 28.5L17.057 1.00001C17.2033 0.746662 17.4137 0.536284 17.667 0.390018C17.9204 0.243751 18.2078 0.166748 18.5003 0.166748C18.7929 0.166748 19.0803 0.243751 19.3336 0.390018C19.587 0.536284 19.7974 0.746662 19.9437 1.00001ZM16.8337 22.6667V26H20.167V22.6667H16.8337ZM16.8337 11V19.3333H20.167V11H16.8337Z"
        fill="#F04646"
      />
    </svg>
  )
}

export default AlertIcon
